<template>
  <div class="login">
    <div class="container">
      <div class="login__header">
        <img class="login__logo" src="@images/logo.png" alt="logo">
      </div>
    </div>
    <div class="login__wrapper">
      <div class="container">
        <form class="login__form" @submit.prevent="send">
          <h1>LOG IN</h1>
          <p>The best solutions for your business</p>
          <ui-input
              :type="'email'"
              :placeholder="'Email'"
              :rules="[isEmail]"
              v-model="email"
          />
          <ui-input
              :type="'password'"
              :placeholder="'Password'"
              :rules="[required]"
              v-model="password"
          />
          <button class="login__button" type="submit" :disabled="!isFormValid">Log In</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, ref} from "vue";
import {ElNotification} from "element-plus";
import {isEmail, isPasswordValid, required} from "@/core/rules/textFieldRules.js";
import UiInput from "@/components/ui/ui-input.vue";

const email = ref('')
const password = ref('')

const isFormValid = computed(() => {
  return (
    isEmail(email.value) === true &&
    isPasswordValid(password.value) === true
  )
})

const send = () => {
  ElNotification({
    message: 'This account does not exist.',
    type: 'error'
  })
}
</script>

<style lang="scss" scoped>
.login {
  background-image: url(@images/mainBg.svg);
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  background-size: cover;
  height: 100vh;

  &__header {
    padding-block: 32px;
  }

  &__logo {
    width: 210px;
  }

  &__wrapper {
    display: grid;
    place-items: center;
  }

  &__form {
    margin-top: 100px;
    width: 738px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin-inline: auto;

    & h1 {
      color: #131313;
      text-align: center;
      font-size: 55px;
      font-weight: 700;
    }

    & p {
      font-family: Inter, sans-serif;
      color: #000;
      text-align: center;
      font-size: 18px;
      font-weight: 400;
    }
  }

  &__button {
    cursor: pointer;
    margin-top: 30px;
    border-radius: 40px;
    background: #2B8BC9;
    padding: 6px 65px;
    transition: 0.2s;

    color: #FFF;
    font-size: 16px;
    font-weight: 700;
    line-height: 28px;

    @include hover {
      box-shadow: 0 0 10px 1px #545AE7;
    }

    &:disabled {
      cursor: not-allowed;
      background: #2576a9;

      @include hover {
        box-shadow: 0 0 0 0 #545AE7;
      }
    }
  }
}

@media (max-width: 850px) {
  .login {
    &__form {
      width: 100%;
    }
  }
}

@media (max-width: 400px) {
  .login {
    &__logo {
      width: 300px;
    }
  }
}
</style>